import Img1 from '../../Kuis/img/1.png'
import Img2 from '../../Kuis/img/2.png'
import Img3 from '../../Kuis/img/3.png'
import Img4 from '../../Kuis/img/4.png'
import Img5 from '../../Kuis/img/5.png'
import Img6 from '../../Kuis/img/6.png'
import Img7 from '../../Kuis/img/7.png'
import Img8 from '../../Kuis/img/8.png'
import Img9 from '../../Kuis/img/9.png'
import Img10 from '../../Kuis/img/10.png'
// import { InlineMath } from "react-katex";
export const quiz = [
    {
        id : 1,
       soalgambar : Img1,
        pertanyaan : "Himpunan penyelesaian sistem pertidaksamaan  2y - x ≤ 2 ; 4x + 3y ≤ 12 ; x ≥ 0 , y ≥ 0 pada gambar terletak di daerah …",
        options : [
            { 
                title : " I",
                op :"a",
                correct : true,
            },
            { 
                title : "II",
                op :"b",
                correct : false,
            },
            { 
                title : "III",
                op :"c",
                correct : false,
            },
            { 
                title : "I dan IV",
                op :"d",
                correct : false,
            },
            { 
                title : "II dan III",
                op :"e",
                correct : false,
            },
        ],                
    },
    {
        id : 2,
        soalgambar : Img2,
        pertanyaan : "Daerah yang tidak diarsir pada gambar dibawah ini adalah himpunan penyelesaian dari sistem pertidaksamaan ....",
        options : [
            { 
                title : "5x + 3y ≤ 30 ; x - 2y ≥ 4 ; x ≥ 0 ; y ≥ 0",
                op :"a",
                correct : false,
            },
            { 
                title : "5x + 3y ≤ 30 ; x - 2y ≤ 4 ; x ≥ 0 ; y ≥ 0",
                op :"b",
                correct : false,
            },
            { 
                title : "3x + 5y ≤ 30 ; 2x - y ≥ 4 ; x ≥ 0 ; y ≥ 0",
                op :"c",
                correct : false,
            },
            { 
                title : "3x + 5y ≤ 30 ; 2x - y ≤ 4 ; x ≥ 0 ; y ≥ 0",
                op :"d",
                correct : true,
            },
            { 
                title : "3x + 5y ≥ 30 ; 2x - y ≤ 4 ; x ≥ 0 ; y ≥ 0",
                op :"e",
                correct : false,
            },
        ],  
    },
    {
        id : 3,
        soalgambar : Img3,
        pertanyaan : " Sistem pertidaksamaan linear dua variabel yang dimana daerahnya tidak diarsir adalah … ",
        options : [
            { 
                title : "3x + 4y < 12",
                op :"a",
                correct : false,
            },
            { 
                title : "3x + 4y > 12",
                op :"b",
                correct : false,
            },
            { 
                title : "3x + 4y ≤ 12",
                op :"c",
                correct : true,
            },
            { 
                title : "3x + 4y ≥ 12",
                op :"d",
                correct : false,
            },
            { 
                title : "4x + 3y ≤ 12",
                op :"e",
                correct : false,
            },
        ],  
    },
    {
        id : 4,
        soalgambar : Img4,
        pertanyaan : " Sistem pertidaksamaan linear dua variabel yang dimana daerahnya tidak diarsir adalah …",
        options : [
            { 
                title : "x + y ≥ -2, 0 ≤ y ≤ 2",
                op :"a",
                correct : false,
            },
            { 
                title : "x - y ≥ 2, 0 ≤ y ≤ -2",
                op :"b",
                correct : false,
            },
            { 
                title : "x + y ≥ -2, 0 ≤ y ≤ -2",
                op :"c",
                correct : false,
            },
            { 
                title : "x - y ≤ 2, 0 ≤ y ≤ 2",
                op :"d",
                correct : true,
            },
            { 
                title : "x + y ≥ 2, 0 ≤ y ≤ -2",
                op :"e",
                correct : false,
            }
        ],  
    },
    {
        id : 5,
        soalgambar : Img5,
        pertanyaan : "Sistem pertidaksamaan linear dua variabel yang dimana daerahnya tidak diarsir adalah…",
        options : [
            { 
                title : "0 < x ≤ 4 , 1 < y ≤ 3",
                op :"a",
                correct : false,
            },
            { 
                title : "3x + 4y ≤ 12, 2x + y ≤ 4",
                op :"b",
                correct : true,
            },
            { 
                title : "2x + 3y ≤ 12, 2x + y ≤ 4",
                op :"c",
                correct : false,
            },
            { 
                title : "3x + 4y ≤ 12, 2x + 2y ≤ 12",
                op :"d",
                correct : false,
            },
            { 
                title : "2x + 4y ≤ 8, 2x + y ≤ 8",
                op :"e",
                correct : false,
            }
        ],  
    },
    {
        id: 6,
        soalgambar : Img6,
        pertanyaan : " Daerah yang tidak diarsir menunjukkan daerah himpunan penyelesaian dari pertidaksamaan ….",
        options : [
            { 
                title : "2x + 3y ≤ 0",
                op :"a",
                correct : false,
            },
            { 
                title : "2x + 3y ≤ 6",
                op :"b",
                correct : true,
            },
            { 
                title : "2x - 3y ≤ 0",
                op :"c",
                correct : false,
            },
            { 
                title : "2x - 3y ≤ 6",
                op :"d",
                correct : false,
            },
            { 
                title : "3x + 2y ≤ 6",
                op :"e",
                correct : false,
            }
        ],  
    },
    {
        id : 7,
        soalgambar : Img7,
        pertanyaan : " Grafik himpunan penyelesaian sistem pertidaksamaan 2x + y ≤ 4 ; x + 2y ≤ 6 ; 3x + 2y ≥ 6; x ≥ 0;  dan  y ≥ 0  adalah daerah ...",
        options : [
            { 
                title : "I",
                op :"a",
                correct : false,
            },
            { 
                title : "II",
                op :"b",
                correct : false,
            },
            { 
                title : "III",
                op :"c",
                correct : false,
            },
            { 
                title : "IV",
                op :"d",
                correct : true,
            },
            { 
                title : "V",
                op :"e",
                correct : false,
            }
        ],  
    },
    {
        id : 8,
        soalgambar : Img8,
        pertanyaan : " Grafik himpunan penyelesaian sistem pertidaksamaan x + 3y ≤ 12; 2x + y ≥ 10; y ≥ 2; x ≥ 0  dan  y ≥ 0  adalah daerah  …",
        options : [
            { 
                title : "I",
                op :"a",
                correct : false,
            },
            { 
                title : "II",
                op :"b",
                correct : false,
            },
            { 
                title : "III",
                op :"c",
                correct : false,
            },
            { 
                title : "IV",
                op :"d",
                correct : true,
            },
            { 
                title : "V",
                op :"e",
                correct : false,
            }
        ],  
    },
    {
        id : 9,
        soalgambar : Img9,
        pertanyaan : "Daerah yang diarsir tersebut merupakan penyelesaian dari sistem pertidaksamaan berikut, yaitu …",
        options : [
            { 
                title : "x + y ≤ 2; x - y ≤ 2 ; x + y ≥ -2; x - y ≥ -2.",
                op :"a",
                correct : true,
            },
            { 
                title : "x - y ≤ 2; x + y ≤ 2 ; x - y ≥ -2; x + y ≥ -2.",
                op :"b",
                correct : false,
            },
            { 
                title :"x + y ≤ 2; x - y ≤ 2 ; x + y ≥ 2; x - y ≥ 2.",
                op :"c",
                correct : true,
            },
            { 
                title : "x - y ≤ -2; x - y ≤ -2 ; x + y ≥ 2; x - y ≥ 2.",
                op :"d",
                correct : false,
            },
            { 
                title : "x + y ≤ 2; x - y ≤ -2 ; x + y ≥ 2; x - y ≥ -2.",
                op :"e",
                correct : false,
            }
        ],  
    },
    {
        id : 10,
        soalgambar : Img10,
        pertanyaan : " Daerah himpunan penyelesaian dari sistem x ≥ 0, 0 ≤ y ≤ 4, 3x + 2y ≤ 12, dan  3x - y ≥ -3 ( x,y  adalah anggota  B)  adalah  …",
        options : [
            { 
                title : "I",
                op :"a",
                correct : false,
            },
            { 
                title : "II",
                op :"b",
                correct : true,
            },
            { 
                title : "III",
                op :"c",
                correct : false,
            },
            { 
                title : "IV",
                op :"d",
                correct : false,
            },
            { 
                title : "V",
                op :"e",
                correct : false,
            }
        ],  
    },    
   
];